const removeHashFromString = (string: string) =>
  typeof string === "string" ? string.trim().replace(/^#/, "") : "";

export default removeHashFromString;
